import { computed, type ComputedRef } from 'vue'

import { Sport } from '@collector/sportsapi-client-legacy'

import { useSportQuery } from './queries/useSportQuery'

export function useSport(): {
  sport: ComputedRef<Sport>
} {
  const { data: sport } = useSportQuery()

  return {
    sport: computed(() => sport.value!),
  }
}
